window.bookCategories = function() {
    const init = () => {
        if ($('.datepick').is(':visible')) {
            updatePicker()
        }

        function updatePicker() {
            var stylecateg = $('.listMobile__top').css('display');
            if (stylecateg == 'none') {
                $('.datepick').datepicker({
                    dateFormat: 'yy-mm-dd',
                    changeMonth: true,
                    changeYear: true,
                    onSelect: function(dateText) {
                        $('#sort-book').trigger('change')
                    }
                });
            } else {
                $('.datepick').datepicker({
                    dateFormat: 'yy-mm-dd',
                    changeMonth: true,
                    changeYear: true,
                    beforeShow: function (input, inst) {
                        var input = $('#datepickmob');
                        var calendar = inst.dpDiv;
                        setTimeout(function () {
                            calendar.position({
                                my: 'left top',
                                at: 'left top',
                                collision: 'none',
                                of: input
                            });
                        }, 1);
                    }
                });
            }
        }

        $("#filterbtn").click(function () {
            $('body').css('overflow', 'hidden');
            $('#listmob').addClass('active');
        });
        $(".-closeFilter").click(function () {
            $("body").removeAttr("style");
            $('#listmob').removeClass('active');
        });
    }

    const sort = () => {
        $(document).on('change', '#sort-book', function() {
            let order = $(this).val(),
                url = window.location.href.split('?')[0];
                url += '?page=1';
    
            $.ajax({
                url: url,
                dataType: 'html',
                type: "GET",
                data: {
                    order: order,
                    age: $('#sort-age').val(),
                    date: $('#datepick').val()
                },
            })
            .done(function(response) {
                $('#list-ajax').html(response);

                $('html, body').animate({
                    scrollTop: $("#list-ajax").parent().parent().offset().top
                }, 1000);
    
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1';  
                window.history.pushState({ path: refresh }, '', refresh);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                console.log(errorThrown);
            });
        })

        $(document).on('change', '#sort-age', function() {
            let age = $(this).val(),
                url = window.location.href.split('?')[0];
                url += '?page=1';
    
            $.ajax({
                url: url,
                dataType: 'html',
                type: "GET",
                data: {
                    order: $('#sort-book').val(),
                    age: age,
                    date: $('#datepick').val()
                },
            })
            .done(function(response) {
                $('#list-ajax').html(response);

                $('html, body').animate({
                    scrollTop: $("#list-ajax").parent().parent().offset().top
                }, 1000);
    
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname +'?page=1';  
                window.history.pushState({ path: refresh }, '', refresh);
            })
            .fail(function(xhr, textStatus, errorThrown) {
                console.log(errorThrown);
            });
        }) 
    }
    
    return {
        init: function() {
            init();
            sort();
        }
    };
}();

window.bookDetail = function() {
    const slick = () => {
        $('.-simage').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 2000,
        });
    }

    const initDom = () => {
        $(".-bRimg").on("click", function () {
            $('.-pRimg').addClass('active');
        });
        $(".-bRaloud").on("click", function () {
            $('.-pRaloud').addClass('active');
        });
        $(".-bReport").on("click", function () {
            $('.-pReport').addClass('active');
        });
        $(".-btnCl").on("click", function () {
            closePopup()
        });
        $('.popup').on("click", function () {
            closePopup()
        })
        $('.popupBox').on('click', function (e) {
            e.stopPropagation();
        })

        function closePopup() {
            $('.popup').removeClass('active');
        }

        $('#buy').on('click', function (e) {
            e.stopPropagation();
            $(this).siblings('button').toggleClass('active')
        });
        $('#buy').hover(function () {
            $(this).siblings('button').toggleClass('hover')
        });
        $(document).on("click", function () {
            $('#buy').prop('checked', false);
            $('#buy').siblings('button').removeClass('active')
        });

        $('.-more').click(function () {
            $('.readSinopsis__content').toggleClass('show');
            if ($(this).html() == 'Read Less<span class="icon-chevron"></span>') {
                $(this).html('Read More<span class="icon-chevron"></span>')
            } else {
                $(this).html('Read Less<span class="icon-chevron"></span>')
            }
        });

        //tab read books
        window.openTab = (evt, cityName) => {
            var i, tablinkcontent, tabbutton;
            tablinkcontent = document.getElementsByClassName("readTab__content");
            for (i = 0; i < tablinkcontent.length; i++) {
                tablinkcontent[i].style.display = "none";
            }
            tabbutton = document.getElementsByClassName("readTab__btn");
            for (i = 0; i < tabbutton.length; i++) {
                tabbutton[i].className = tabbutton[i].className.replace(" active", "");
            }
            document.getElementById(cityName).style.display = "block";
            evt.currentTarget.className += " active";

            //tab scroll mobile
            let act = $('.readTab__btn.active');
            if (act.length > 0) {
                let msp = act.position().left;
                $('.readTab__list').animate({
                    scrollLeft: msp - 10
                });
            }
        }

        window.showReviewForm = () => {
            $('#form-review').show();
            $('#no-review').hide();
        }

        window.openPopReport = (id) => {
            $('#popReport').addClass('active');
            $('#msg-report').html(null);
            var review_id = $('#popReport').find('#form-report #review_id');
            review_id.val(id);
        }
    }

    const formReview = () => {
        $('#form-review').validate({
            ignore: null,
            rules: {
                content: {
                    required: true,
                }
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
            },
            errorElement: 'div',
            errorClass: 'formError__txt display-flex',
            submitHandler: function (form) {
                $.ajax({
                    type: "POST",
                    url: $(form).attr('action'),
                    data: $(form).serialize(),
                    success: function(data) { 
                        $('#form-review')[0].reset();
                        
                        $('#list-review').html(data);
                        $('html, body').animate({
                            scrollTop: $("#list-review").offset().top
                        }, 1000);
                        setTimeout(function () {
                            $('.alert').fadeOut('slow', function(){
                                $(this).remove();
                            });
                        }, 5000);
                    },
                    error: function (err) {
                        if (422 == err.status) {
                            $.each(err.responseJSON.errors, function (i, error) {
                                var el = $(document).find('[name="'+ i +'"]');
                                el.after($('<p class="formError">' + error[0] + '</p>'));
                            });
    
                            setTimeout(function() {
                                $(".formError").remove();
                            }, 2000);
                        }
                        if(403 == err.status) {
                            window.location.href = HOST_URL + '/email/verify';
                        }
                    }
                });
                return false;
            }
        });

        $('#form-report').validate({
            rules: {
                report_reason_id: {
                    required: true,
                    digits: true,
                },
                review_id: {
                    required: true,
                    digits: true,
                }
            },
            errorPlacement: function(error, element) {
                error.addClass('subscribe');
                if (element.attr("name") == "report_reason_id") {
                    $('div.formError__txt.subscribe').remove();
                    error.insertAfter(element.closest('#form-report'));
                } else {
                    error.insertAfter(element);
                }
            },
            success: function (label, element) {
                if ($(element).attr("name") == "report_reason_id") {
                    $('div.formError__txt.subscribe').remove();
                } 
            },
            errorElement: 'div',
            errorClass: 'formError__txt display-flex',
            submitHandler: function (form) {
                $.ajax({
                    type: "POST",
                    url: $(form).attr('action'),
                    data: $(form).serialize(),
                    success: function(data) { 
                        $('#form-report')[0].reset();
                        $('#msg-report').html(data.message);
                        setTimeout(function() {
                            $('.popup').removeClass('active');
                        }, 2000);
                    },
                    error: function (err) {
                        if (err.status == 422) {
                            $.each(err.responseJSON.errors, function (i, error) {
                                $('#msg-report').html(error[0]);
                            });
                        }
                        if(403 == err.status) {
                            window.location.href = HOST_URL + '/email/verify';
                        }
                    }
                });
                return false;
            }
        });
    }

    return {
        init: function() {
            slick();
            initDom();
            formReview();
        }
    };
}()